import React from "react";
import { Modal } from "semantic-ui-react";

const MessageModel = (props) => {
  const { open, size, title, message } = props;
  return (
    <Modal
      size={size}
      open={open}
      header={title}
      content={message}
      style={{ marginTop: "200px !important" }}
      actions={[{ key: "done", content: "Done", positive: true }]}
    />
  );
};

export default MessageModel;



// WEBPACK FOOTER //
// ./src/components/dialogs/MessageModel.js